import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TruncateTextPipe } from 'features/src/lib/donations/pipes/truncate-text.pipe';

export interface DonationSummaryVM {
  nameEn: string;
  nameEs: string;
  descriptionEn: string;
  descriptionEs: string;
  imageUrl: string;
}

@Component({
    selector: 'don-campaign-summary',
    imports: [CommonModule, TranslateModule, TruncateTextPipe],
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignSummaryComponent {
  @Input({ required: true }) campaign: DonationSummaryVM | null = null;

  fallback = 'assets/Image/Story/banner.webp';
  showFullDescription = false;
  constructor(public translate: TranslateService) { }

  get name(): string | undefined {
    if (!this.campaign) return;
    return this.translate.currentLang === 'es' ? this.campaign.nameEs : this.campaign.nameEn;
  }

  get description(): string | undefined {
    if (!this.campaign) return;
    return this.translate.currentLang === 'es' ? this.campaign.descriptionEs : this.campaign.descriptionEn;
  }
}
